import styles from './style.module.css';
import Modal from 'react-responsive-modal';
import alert from '../../../../assets/images/alert.png';

interface IModalHasAnswered {
  modalIsOpen: boolean;
  toggleModal: () => void;
  cancelAnswer: () => void;
}

export function ModalHasAnswered({
  modalIsOpen,
  toggleModal,
  cancelAnswer,
}: IModalHasAnswered) {
  return (
    <Modal
      open={modalIsOpen}
      onClose={() => {
        toggleModal();
        cancelAnswer();
      }}
      center
    >
      <div className={styles.contents}>
        <div className="d-flex justify-content-center">
          <img className={styles.alert} src={alert} alt="" />
        </div>
        <h1 className={styles.title}>
          <b className={styles.highlightText}>OPS!</b> Você já respondeu esse{' '}
          <b>QUIZ</b>!
        </h1>
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={() => {
            toggleModal();
            cancelAnswer();
          }}
          className={styles.btnAgree}
          type="button"
        >
          Voltar
        </button>
      </div>
    </Modal>
  );
}
